export default "__VITE_ASSET__B6I1b3zx__"